import React from 'react';
import Formats from 'utils/formats';
import { CampaignObjectiveKeyLabel } from 'utils/types';
import './styles.scss';

interface Props {
  data: any;
}

const CampaignsDetailsDataSelection: React.FC<Props> = ({ data }) => (
  <div className="campaigns-details-data-selection">
    <div className="details-main">
      <div>
        <span className="title">Campaign Name</span>
        {data.name}
      </div>
      <div>
        <span className="title">Store Group Name</span>
        {data.storeGroupName}
      </div>
      <div>
        <span className="title">Item Group Name</span>
        {data.itemGroupName}
      </div>
      <div>
        <span className="title">Campaign Objective</span>
        {CampaignObjectiveKeyLabel[data.objective]}
      </div>
      <div className="dates-container">
        <div className="start-date">
          <span className="date-title">Start Date</span>
          {data.startDate !== null ? <span>{Formats.date(data.startDate)}</span> : <span />}
        </div>
        <div>
          <span className="date-title">End Date</span>
          {data.endDate !== null ? <span>{Formats.date(data.endDate)}</span> : <span />}
        </div>
      </div>
      <div>
        <span className="title">Notes</span>
        {data.notes}
      </div>
    </div>
  </div>
);

export default CampaignsDetailsDataSelection;
